import OtaUpgradeStatusLocationsContainer from './OtaUpgradeStatusLocationsContainer';

export default OtaUpgradeStatusLocationsContainer;
